import { useQuery } from '@apollo/client';
import { MY_VOUCHING_CREDITS_QUERY } from '../graphql/resolvers/vouchQueries/myVouchingCredits.gql';

export function useVouchingCredits() {
  const { data, loading, refetch } = useQuery(MY_VOUCHING_CREDITS_QUERY, {
    fetchPolicy: 'cache-and-network',
    skip: import.meta.env.VITE_ENABLE_VOUCHING !== 'true',
  });
  return {
    available: data?.myVouchingCredits.available ?? 0,
    committed: data?.myVouchingCredits.committed ?? 0,
    loading,
    refetch,
  };
}
